import "./requestSentDetails.css";
import { useCustomContext } from "../CustomComponents/CustomComponents";
import { useState, useEffect, useRef } from "react";
import DatasetDS from "../../DataServices/DatasetDs";
import AgenciesDS from "../../DataServices/AgenciesDs";
import RequestSentDetailsDS from "../../DataServices/RequestSentDetailsDS";
import { FaEye } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { FaCopy } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { FaAsterisk } from "react-icons/fa6";
import { IoAddCircleOutline } from "react-icons/io5";
import { GoDotFill } from "react-icons/go";
import { FaExternalLinkSquareAlt } from "react-icons/fa";
import { insertLog } from "../Logs/InsertLog";
import { TbTriangleFilled } from "react-icons/tb";
import { TbTriangleInvertedFilled } from "react-icons/tb";
import { LuTriangle } from "react-icons/lu";
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { BiSolidPhoneCall } from "react-icons/bi";
import DialModal from "./DialModal";
import { PiLink } from "react-icons/pi";
import { BsPinAngleFill } from "react-icons/bs";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { S3Client } from "@aws-sdk/client-s3";
const RequestSentDetails = () => {

    const datasetDS = new DatasetDS();
    const agenciesDS = new AgenciesDS();
    const requestSentDS = new RequestSentDetailsDS();
    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];


    const { showAlert, stopHudRotation, hud, showToast } = useCustomContext();
    const [datasets, setDatasets] = useState([]);
    const [datasetID, setDatasetID] = useState("");
    const [agencies, setAgencies] = useState([]);
    const [agencyId, setAgencyId] = useState("");
    const [agencySearch, setAgencySearch] = useState("All Agencies");
    const [isAgencyDropdownOpen, setIsAgencyDropdownOpen] = useState(false);
    const [showAllAgencyOptions, setShowAllAgencyOptions] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const [requestDetails, setRequestDetails] = useState([]);
    const [agencyMongoId, setAgencyMongoId] = useState(""); // mongo _id
    const [selectedAgencyDetails, setSelectedAgencyDetails] = useState(null);
    const [isOpen, setIsOpen] = useState(true);
    const [requestSentByPage, setrequestSentByPage] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [loadedPages, setLoadedPages] = useState([]);
    const [hasMorePages, setHasMorePages] = useState(true);
    const [textArea, setTextArea] = useState("");
    const [selectedRecordId, setSelectedRecordId] = useState(null);

    const [showStatusModal, setShowStatusModal] = useState(false);
    const [selectedStatusRecord, setSelectedStatusRecord] = useState(null);
    const [modalStatus, setModalStatus] = useState("Sent");
    const [statusNotes, setStatusNotes] = useState("");

    const [isDatasetPatched, setIsDatasetPatched] = useState(false);
    const [isAgenciesLoaded, setIsAgenciesLoaded] = useState(false);
    const [isAgencyPatched, setIsAgencyPatched] = useState(false);
    const [isFromList, setIsFromList] = useState(false);
    const [pageSize, setPageSize] = useState(25);
    const [isPageSizeEnabled, setIsPageSizeEnabled] = useState(false);

    // ✅ Cheque Modal States
    const [showChequeModal, setShowChequeModal] = useState(false);
    const [chequePaymentTo, setChequePaymentTo] = useState("");
    const [chequeAmount, setChequeAmount] = useState("");
    const [selectedChequeRecordId, setSelectedChequeRecordId] = useState(null);
    const navigate = useNavigate();
    // ✅ View Cheque Modal States
    const [showViewChequeModal, setShowViewChequeModal] = useState(false);
    const [chequePdfUrl, setChequePdfUrl] = useState("");

    const PAGE_SIZE = 10;
    const location = useLocation();
    const { agencyIDfromList, datasetIDfromList } = location.state || {};
    const [totalRecords, setTotalRecords] = useState(0);
    const [sortColumn, setSortColumn] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [search, setSearch] = useState('');
    const [pageSortState, setPageSortState] = useState({});

    const [lastSortedColumn, setLastSortedColumn] = useState("");
    const [lastSortOrder, setLastSortOrder] = useState("");
    const [noteerror, setNoteError] = useState("");

    const [statusNoteError, setstatusNoteError] = useState('');
    const [dialOpen, setDialOpen] = useState(false);
    const [dialRequestId, setDialRequestId] = useState("");

    useEffect(() => {
        const init = async () => {
            if (datasetIDfromList && agencyIDfromList) {
                setIsFromList(true);
            } else {
                setIsFromList(false);
            }

            if (!datasetIDfromList) return;

            hud("Please wait...");

            try {
                setIsDatasetPatched(false);
                setIsAgenciesLoaded(false);

                setDatasetID(datasetIDfromList);
                setIsDatasetPatched(true);

                await fetchAgencieByDataset(datasetIDfromList);

            } catch (err) {
                console.error(err);
            } finally {
                stopHudRotation();
            }
        };

        init();

    }, [datasetIDfromList, agencyIDfromList]);

    useEffect(() => {
        localStorage.removeItem('agencyDetailsPayload');
    }, [])

    useEffect(() => {
        if (!isDatasetPatched) return;
        if (!isAgenciesLoaded) return;
        if (!agencyIDfromList) return;

        const selectedAgency = agencies.find(
            a => a.agencyID == agencyIDfromList
        );

        if (!selectedAgency) return;

        setAgencyId(agencyIDfromList);
        setAgencySearch(`${selectedAgency.agencyID} - ${selectedAgency.agencyName}`);
        setAgencyMongoId(selectedAgency._id);

        callViewApi(selectedAgency._id, agencyIDfromList);

    }, [isDatasetPatched, isAgenciesLoaded, agencies, agencyIDfromList]);

    const pendingRestoreRef = useRef(null);

    useEffect(() => {
        const f = pendingRestoreRef.current;
        if (!f) return;
        if (!f.datasetID || !f.fromDate || !f.toDate) return;
        pendingRestoreRef.current = null;
        hud("Please Wait...");
        const offset = (f.currentPage - 1) * f.pageSize;
        requestSentDS.AP_SentRequests_GET({
            agencyID: f.agencyId,
            datasetID: f.datasetID,
            fromDate: f.fromDate,
            toDate: f.toDate,
            limit: f.pageSize,
            offset: offset
        }).then(response => {
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200 && Array.isArray(body.records)) {
                let records = body.records;
                if (f.lastSortedColumn) {
                    records = sortRecords(records, f.lastSortedColumn, f.lastSortOrder);
                }
                setrequestSentByPage({ [f.currentPage]: records });
                setLoadedPages([f.currentPage]);
                setHasMorePages(body.isMoreRecordsAvailable);
                setTotalRecords(body.totalRecords);
            }
        }).catch(err => {
            console.error("Re-fetch on back navigation failed:", err);
        }).finally(() => {
            stopHudRotation();
        });
    }, [agencies]);

    useEffect(() => {
        const today = new Date();
        const formatDate = (date) => date.toISOString().split("T")[0];
        const currenttDate = formatDate(today);
        const sevenDaysBack = new Date(today);
        sevenDaysBack.setDate(today.getDate() - 7);
        const saved = sessionStorage.getItem("reqSent_filters");
        const cameFromRequestDetail = location.state?.fromRequestDetail === true;
        if (saved && cameFromRequestDetail) {
            sessionStorage.removeItem("reqSent_filters");
            const f = JSON.parse(saved);
            setDatasetID(f.datasetID);
            setAgencyId(f.agencyId);
            setAgencyMongoId(f.agencyMongoId);
            setFromDate(f.fromDate);
            setToDate(f.toDate);
            setCurrentPage(f.currentPage);
            setPageSize(f.pageSize);
            setLastSortedColumn(f.lastSortedColumn);
            setLastSortOrder(f.lastSortOrder);
            setSelectedAgencyDetails(f.selectedAgencyDetails);
            setIsOpen(f.isOpen);
            setIsPageSizeEnabled(true);
            setrequestSentByPage({});
            setLoadedPages([]);
            setHasMorePages(true);
            setTotalRecords(f.totalRecords);
            if (f.datasetID) {
                fetchAgencieByDataset(f.datasetID);
            }
            if (f.datasetID && f.fromDate && f.toDate) {
                pendingRestoreRef.current = f;
            }
        }
        else {
            sessionStorage.removeItem("reqSent_filters");
            setToDate(currenttDate);
            setFromDate(formatDate(sevenDaysBack));
        }
        fetchDatasets();

        const handleClickOutside = (event) => {
            if (!event.target.closest(".req-status-wrapper")) {
                setOpenReqDropdownId(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [])

    const fetchDatasets = async () => {
        try {
            const req = {};
            const response = await datasetDS.AP_Dataset_List_GET(req);

            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200 && Array.isArray(body.records)) {

                const accessLevel = localStorage.getItem('accessLevel');
                const isAdmin = accessLevel === '1';

                const allowedDatasets = JSON.parse(localStorage.getItem('winterSoldierDatasets') || '[]');

                const permittedDatasets = isAdmin
                    ? body.records
                    : body.records.filter(item => allowedDatasets.includes(item.datasetID)
                    );

                const requestDatasets = permittedDatasets.filter(item =>
                    // item.entryType === "Request Based PDF Entry" && item.datasetID === "NJ-103"
                    item.entryType === "Request Based PDF Entry"
                );
                setDatasets(requestDatasets);
            }
            else {
                showAlert(body?.message || "Failed to load Datasets.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
                insertLog(
                    `${userName} failed to fetch datasets`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    '',
                    'GET',
                    'AP_Dataset_List_GET',
                    'FAILED',
                    'Failed to load datasets'
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch datasets`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'GET',
                'AP_Dataset_List_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Something went wrong while fetching Datasets.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
        }
    };

    const fetchAgencieByDataset = async (datasetID) => {
        try {
            const req = { datasetID };
            const response = await requestSentDS.WS_Agency_ByDatasetID_GET(req);

            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && Array.isArray(body.records)) {
                setAgencies(body.records);
                setIsAgenciesLoaded(true);


            } else {
                showAlert(body?.message || "Failed to load Agencies.", [
                    { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
                ]);

                insertLog(
                    `${userName} failed to fetch Agencies for dataset ${datasetID}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    '',
                    'GET',
                    'WS_Agency_ByDatasetID_GET',
                    'FAILED',
                    `failed to fetch agencies for dataset ${datasetID}`
                );

            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch agencies for dataset ${datasetID}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'GET',
                'WS_Agency_ByDatasetID_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Something went wrong while fetching Agencies.", [
                { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
            ]);
        }
    };




    const getAgencyLabel = (agency) =>
        `${agency.agencyID} - ${agency.agencyName}`;


    const handleSearch = async (e, agencyIDOverride) => {
        if (e) e.preventDefault();
        let effectiveAgencyId = agencyIDOverride ?? agencyId;
        const enteredAgencyText = agencySearch.trim();

        if (!effectiveAgencyId && enteredAgencyText && enteredAgencyText.toLowerCase() !== "all agencies") {
            const exactAgencyMatch = agencies.find(
                (agency) => getAgencyLabel(agency).toLowerCase() === enteredAgencyText.toLowerCase()
            );

            if (exactAgencyMatch) {
                effectiveAgencyId = exactAgencyMatch.agencyID;
                setAgencyId(exactAgencyMatch.agencyID);
                setAgencySearch(getAgencyLabel(exactAgencyMatch));
            } else {
                showToast({ message: "Please select a valid agency from the dropdown" });
                setrequestSentByPage({});
                setLoadedPages([]);
                setCurrentPage(1);
                setHasMorePages(true);
                setTotalRecords(0);
                return;
            }
        }

        if (!datasetID || datasetID === "Select Dataset") {
            showToast({ message: "Please select a Dataset" });
            return;
        }
        if (!fromDate) {
            showToast({ message: "Please select From Date" });
            return;
        }

        if (!toDate) {
            showToast({ message: "Please select To Date" });
            return;
        }
        if (new Date(toDate) < new Date(fromDate)) {
            showToast({ message: "To Date cannot be earlier than From Date" });
            return;
        }
        hud("Please Wait..")

        try {

            setCurrentPage(1);
            setrequestSentByPage({});
            setLoadedPages([]);
            setHasMorePages(true);

            await LoadRecords(1, true, null, effectiveAgencyId);

        } catch (err) {
            showAlert(err.message || "Something went wrong while fetching requestSentDetails.", [
                { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
            ]);
        }
        finally {
            stopHudRotation();
        }
    };

    const totalPages = Math.ceil(totalRecords / pageSize);


    const requestSentData = requestSentByPage[currentPage] || [];

    const formatListValue = (value) => {
        if (Array.isArray(value)) return value.filter(Boolean).join(", ");
        return value || "";
    };


    // at top of component
    const isFetchingAgenciesRef = useRef(false);

    // replace your handleDatasetChange with this
    const handleDatasetChange = async (e) => {
        setIsFromList(false);
        setIsPageSizeEnabled(false);
        setPageSize(25);
        const selectedDatasetID = e.target.value;
        setDatasetID(selectedDatasetID);

        // Clear dependent dropdowns
        setAgencyId("");
        setAgencySearch("All Agencies");
        setIsAgencyDropdownOpen(false);
        setShowAllAgencyOptions(false);
        setAgencyMongoId("");
        setSelectedAgencyDetails(null);
        setrequestSentByPage({});
        setLoadedPages([]);
        setCurrentPage(1);
        setHasMorePages(true);
        setLastSortedColumn(null);
        setLastSortOrder(null);
        setTotalRecords(0);

        if (!selectedDatasetID) return;

        // Prevent concurrent calls
        if (isFetchingAgenciesRef.current) return;
        isFetchingAgenciesRef.current = true;

        try {
            hud("Loading agencies...");               // your custom HUD
            // Ensure fetchAgencieByDataset returns a promise and sets `agencies`
            await fetchAgencieByDataset(selectedDatasetID);
            // optionally auto-select first agency if you want:
            // const items = await fetchAgencieByDataset(selectedDatasetID);
            // if (items && items.length) { setAgencyId(items[0].agencyID); setAgencyMongoId(items[0]._id || items[0].id); }
        } catch (err) {
            console.error("Error fetching agencies:", err);
            showAlert("Failed to load agencies. Please try again.", [
                { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
            ]);
        } finally {
            stopHudRotation();                         // your custom stop
            isFetchingAgenciesRef.current = false;
        }
    };




    const handlePageChange = async (page) => {
        setCurrentPage(page);
        if (!requestSentByPage[page]) {
            await LoadRecords(page);
        }
        else if (lastSortedColumn) {
            setrequestSentByPage(prev => ({
                ...prev,
                [page]: sortRecords(prev[page], lastSortedColumn, lastSortOrder)
            }));
        }
    };

    const LoadRecords = async (page, reset = false, size = null, agencyIDOverride) => {

        const effectiveSize = size ?? pageSize;
        const effectiveAgencyId = agencyIDOverride ?? agencyId;
        try {
            hud("Please Wait..");
            if (!reset && loadedPages.includes(page)) return;

            const offset = (page - 1) * pageSize;

            const requestData = {
                agencyID: effectiveAgencyId,
                datasetID: datasetID,
                fromDate: fromDate,
                toDate: toDate,
                limit: effectiveSize,
                offset: offset
            };

            const response = await requestSentDS.AP_SentRequests_GET(requestData);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && Array.isArray(body.records)) {

                let records = body.records;

                if (lastSortedColumn) {
                    records = sortRecords(records, lastSortedColumn, lastSortOrder);
                }

                if (reset) {
                    setrequestSentByPage({ [page]: records });
                    setLoadedPages([page]);
                } else {
                    setrequestSentByPage(prev => ({ ...prev, [page]: records }));
                    setLoadedPages(prev => prev.includes(page) ? prev : [...prev, page]);
                }
                setHasMorePages(body.isMoreRecordsAvailable);
                setIsPageSizeEnabled(true);
                setTotalRecords(body.totalRecords);

            }
            else {
                showAlert(body?.message || "Failed to load Sent requests.", [
                    { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
                ]);
                insertLog(
                    `${userName} Failed to load Sent requests`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    '',
                    'GET',
                    'AP_SentRequests_GET',
                    'FAILED',
                    'Failed to load sent requests'
                );
            }
        }
        catch (error) {
            insertLog(
                `${userName} failed to load sent requests`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'GET',
                'AP_SentRequests_GET',
                'FAILED',
                error.message
            );
            console.error("LoadRecords Error:", error);
            showAlert(error.message || "Something went wrong. Please try again.", [
                { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
            ]);
        }
        finally {
            stopHudRotation();
        }

    };



    const handleFromDateChange = (e) => {
        const selectedFromDate = e.target.value;
        setIsPageSizeEnabled(false);
        setPageSize(25);
        setFromDate(selectedFromDate);
        setrequestSentByPage({});
        setLoadedPages([]);
        setCurrentPage(1);
        setHasMorePages(true);
        setTotalRecords(0);

    }

    const handleToDateChange = (e) => {
        const selectedtoDate = e.target.value;
        setIsPageSizeEnabled(false);
        setPageSize(25);
        setToDate(selectedtoDate);
        setrequestSentByPage({});
        setLoadedPages([]);
        setCurrentPage(1);
        setHasMorePages(true);
        setTotalRecords(0);

    }

    const selectedAgencyForFilter = agencies.find((agency) => agency.agencyID == agencyId);
    const selectedAgencyLabel = selectedAgencyForFilter
        ? getAgencyLabel(selectedAgencyForFilter)
        : "All Agencies";

    const agencySearchText = agencySearch === selectedAgencyLabel || agencySearch === "All Agencies"
        ? ""
        : agencySearch.trim().toLowerCase();

    const filteredAgencyOptions = showAllAgencyOptions
        ? agencies
        : agencySearchText
            ? agencies.filter((agency) =>
                getAgencyLabel(agency).toLowerCase().includes(agencySearchText)
            )
            : agencies;

    useEffect(() => {
        if (agencyId && selectedAgencyForFilter) {
            setAgencySearch(getAgencyLabel(selectedAgencyForFilter));
        }
    }, [agencyId, selectedAgencyForFilter]);

    const handleAgencySearchChange = (e) => {
        const value = e.target.value;
        setAgencySearch(value);
        setIsAgencyDropdownOpen(true);
        setShowAllAgencyOptions(false);

        if (agencyId) {
            setAgencyId("");
            setAgencyMongoId("");
            setSelectedAgencyDetails(null);
        }

        setrequestSentByPage({});
        setLoadedPages([]);
        setCurrentPage(1);
        setHasMorePages(true);
        setTotalRecords(0);
    };



    const phoneNumber = selectedAgencyDetails?.agencyPhoneNumbers?.find(
        (phone) => phone.isPrimary === true
    )?.number;

    const handleAgencyKeyDown = (e) => {
        if (e.key === "Enter" && filteredAgencyOptions.length > 0) {
            e.preventDefault();
            selectAgencyOption(filteredAgencyOptions[0]);
        }

        if (e.key === "Escape") {
            setIsAgencyDropdownOpen(false);
        }
    };

    const selectAllAgencies = () => {
        setAgencySearch("All Agencies");
        setIsAgencyDropdownOpen(false);
        setShowAllAgencyOptions(false);
        updateAgencySelection("");
    };

    const selectAgencyOption = (agency) => {
        setAgencySearch(getAgencyLabel(agency));
        setIsAgencyDropdownOpen(false);
        setShowAllAgencyOptions(false);
        updateAgencySelection(agency.agencyID);
    };

    const updateAgencySelection = async (selectedAgencyID) => {
        setIsFromList(false);
        setIsPageSizeEnabled(false);
        setPageSize(25);
        console.log("selectedAgencyID", selectedAgencyID);
        setAgencyId(selectedAgencyID);

        setrequestSentByPage({});
        setLoadedPages([]);
        setCurrentPage(1);
        setHasMorePages(true);
        setLastSortedColumn(null);
        setLastSortOrder(null);
        setTotalRecords(0);

        if (!selectedAgencyID) {
            // Reset if "Select Agency" is chosen
            setAgencySearch("All Agencies");
            setSelectedAgencyDetails(null);
            setAgencyMongoId("");
            return;
        }

        // Ensure agencies is an array
        const selectedAgency = Array.isArray(agencies)
            ? agencies.find(ds => ds.agencyID == selectedAgencyID)
            : null;

        if (!selectedAgency) {
            showAlert("Selected agency not found.", [
                { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
            ]);
            return;
        }

        // Use _id if available, fallback to id
        const mongoId = selectedAgency._id || selectedAgency.id;
        setAgencyMongoId(mongoId);

        callViewApi(mongoId, selectedAgencyID);
    };


    const callViewApi = async (id, agencyIDParam) => {
        hud("Please Wait...")
        try {
            const req = { id };
            const response = await agenciesDS.AP_Agency_ById_GET(req);

            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && body.record) {

                setSelectedAgencyDetails(body.record);

                // ⭐ ONLY trigger handleSearch if user came from list screen
                if (isFromList) {
                    handleSearch(null, agencyIDParam);
                    setIsFromList(false);
                }

            } else {
                showAlert(body?.message || "Agency details not found.", [
                    { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
                ]);
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch agency details for id ${id}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                id || '',
                'GET',
                'AP_Agency_ById_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Failed to load Agency details.", [
                { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
            ]);
        }
        finally {
            stopHudRotation();
        }
    };

    const getAgencyRecordForDetailsNavigation = async (agency) => {
        const id = agency?._id || agency?.id;
        if (!id) return agency || null;

        hud("Please Wait...");
        try {
            const response = await agenciesDS.AP_Agency_ById_GET({ id });
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && body.record) {
                return body.record;
            }
        } catch (error) {
            console.warn("Unable to fetch full agency details before navigation", error);
        } finally {
            stopHudRotation();
        }

        return agency || null;
    };


    // const handleViewPDF = async (id) => {
    //     try {
    //         hud("Loading PDF...");

    //         const req = { _id: id };

    //         const response = await requestSentDS.WS_SentPdfData_ByID_GET(req);

    //         const data = response.data;

    //         const base64String = data.body;

    //         if (data.statusCode === 200 && base64String) {

    //             console.log("base64String", base64String);

    //             // Convert Base64 → Binary
    //             const byteCharacters = atob(base64String);
    //             const byteNumbers = new Array(byteCharacters.length);

    //             for (let i = 0; i < byteCharacters.length; i++) {
    //                 byteNumbers[i] = byteCharacters.charCodeAt(i);
    //             }

    //             const byteArray = new Uint8Array(byteNumbers);

    //             // Create PDF Blob
    //             const blob = new Blob([byteArray], { type: "application/pdf" });

    //             // Open in new tab
    //             const blobUrl = URL.createObjectURL(blob);
    //             window.open(blobUrl, "_blank");
    //         }
    //         else {
    //             showAlert(data.message || "Error loading PDF.", [
    //                 { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
    //             ]);
    //             insertLog(
    //                 `${userName} failed to view PDF for ${id}`,
    //                 0,
    //                 useremail,
    //                 hud,
    //                 stopHudRotation,
    //                 showAlert,
    //                 '',
    //                 'GET',
    //                 'WS_SentPdfData_ByID_GET',
    //                 'FAILED',
    //                 `failed to view PDF for ${id}`
    //             );
    //         }

    //     } catch (err) {
    //         insertLog(
    //             `${userName} failed to view PDF for ${id}`,
    //             0,
    //             useremail,
    //             hud,
    //             stopHudRotation,
    //             showAlert,
    //             '',
    //             'GET',
    //             'WS_SentPdfData_ByID_GET',
    //             'FAILED',
    //             err.message
    //         );
    //         showAlert(err.message || "Error loading PDF.", [
    //             { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
    //         ]);
    //     } finally {
    //         stopHudRotation();
    //     }
    // };



    const normalizeBucketNamePart = (value) => (
        String(value)
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "-")
            .replace(/-+/g, "-")
            .replace(/^-+|-+$/g, "")
    );

    const handleViewPDF = async (s3Key, datasetID, datasetName) => {
        if (!s3Key) {
            showAlert("No file available to preview.", [
                { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
            ]);
            return;
        }

        try {
            hud("Generating preview...");

            const idToken = localStorage.getItem("idToken");

            const bucketName = `${normalizeBucketNamePart(datasetID)}-${normalizeBucketNamePart(datasetName)}-files-${process.env.REACT_APP_ALIAS}`;
            console.log("bucketName", bucketName);

            const s3 = new S3Client({
                region: process.env.REACT_APP_AWS_REGION,
                credentials: fromCognitoIdentityPool({
                    clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                    identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                    logins: {
                        [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
                            idToken,
                    },
                }),
            });

            const { getSignedUrl } = await import("@aws-sdk/s3-request-presigner");
            const { GetObjectCommand } = await import("@aws-sdk/client-s3");

            const command = new GetObjectCommand({
                Bucket: bucketName,
                Key: s3Key,
                ResponseContentDisposition: "inline",
                ResponseContentType: "application/pdf",
            });

            const signedUrl = await getSignedUrl(s3, command, { expiresIn: 300 }); // 5 min
            window.open(signedUrl, "_blank");

        } catch (err) {
            console.error("Presigned URL error:", err);
            showAlert("Failed to generate preview. Please try again.", [
                { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
            ]);
        } finally {
            stopHudRotation();
        }
    };



    const handleCopy = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                showToast({ message: `Request Id copied to clipboard!` });
            })
            .catch(() => {
                showToast({ message: "Failed to copy!" });
            });
    };

    const [openReqDropdownId, setOpenReqDropdownId] = useState(null);
    const [rowStatus, setRowStatus] = useState({});
    const reqStatusOptions = ["Escalated", "Closed-Data Received", "Closed-No Data", "Payment Pending", "Payment Closed"];
    const dropdownRef = useRef(null);

    const viewHighlightFileds = ["Sent", "Escalated", "Closed-Data Received", "Closed-No Data", "Payment Pending", "Payment Closed"];


    const [showAddModal, setShowAddModal] = useState(false);

    const handleAddTextarea = () => {
        setTextArea('');
        setNoteError('');
        setShowAddModal(true);
    };

    const handleCloseModal = () => {
        setShowAddModal(false);
        setNoteError('');
    };

    const [showNotesModal, setShowNotesModal] = useState(false);
    const [currentNotes, setCurrentNotes] = useState([]);

    const handleViewNotes = (notes) => {
        setCurrentNotes(notes || []);
        setShowNotesModal(true);
    };

    const handleCloseNotesModal = () => {
        setShowNotesModal(false);
        setCurrentNotes([]);
    };

    const handleTextSubmit = async (e) => {
        e.preventDefault();

        const trimmedText = textArea.trim();

        if (!trimmedText) {
            setNoteError("Please enter a note.");
            return;
        }

        setNoteError("");

        const LoggedEmail = localStorage.getItem("email");
        hud("Updating Notes.");

        try {
            const req = {
                _id: selectedRecordId,
                text: trimmedText,
                updated_by_email_id: LoggedEmail,
            };

            console.log("PayloadNote", req);

            const response = await requestSentDS.WS_OutgoingRequest_Notes_ByID_UPDATE(req);
            const data = response.data;

            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && body.message === "Note added successfully") {
                console.log("New Note:", body.note);
                handleSearch();
                insertLog(
                    `${userName} added a note for '${selectedRecordId}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    selectedRecordId || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Notes_ByID_UPDATE',
                    'SUCCESS',
                    ''
                );
            } else {
                showAlert(body?.message || "Unable to add note.", [
                    { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
                ]);
                insertLog(
                    `${userName} failed to add a note for '${selectedRecordId}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    selectedRecordId || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Notes_ByID_UPDATE',
                    'FAILED',
                    `failed to add a note for ${selectedRecordId}`
                );
            }

        } catch (err) {
            insertLog(
                `${userName} failed to add a note for '${selectedRecordId}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                selectedRecordId || '',
                'UPDATE',
                'WS_OutgoingRequest_Notes_ByID_UPDATE',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Failed to add note.", [
                { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
            ]);
        } finally {
            stopHudRotation();
        }

        setShowAddModal(false);   // close modal
    };

    const openStatusModal = (req) => {
        // Patch status
        setModalStatus(req.outgoingRequest_Status || "Sent");

        // Patch notes
        setStatusNotes("");

        // Store selected record if needed for submit
        setSelectedStatusRecord(req);

        setShowStatusModal(true);

        setstatusNoteError('');
    };

    const handleStatusSubmit = async (e) => {
        e.preventDefault();

        const trimmedNotes = statusNotes.trim();

        if (!trimmedNotes) {
            setstatusNoteError("Please enter a note.");
            return;
        }

        const LoggedEmail = localStorage.getItem("email");
        hud("Updating Status.");

        try {
            const req = {
                _id: selectedStatusRecord.id,
                text: trimmedNotes,
                addedBy: LoggedEmail,
                outgoingRequest_Status: modalStatus
            };


            const response = await requestSentDS.WS_OutgoingRequest_Status_ByID_UPDATE(req);
            const data = response.data;

            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && body.message === "Status updated successfully") {
                handleSearch();
                insertLog(
                    `${userName} updated the status to "${modalStatus}" for ${selectedStatusRecord.id}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    selectedStatusRecord.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Status_ByID_UPDATE',
                    'SUCCESS',
                    ''
                );
                setStatusNotes("");
                setstatusNoteError("");

            } else {
                showAlert(body?.message || "Unable to update status.", [
                    { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
                ]);
                insertLog(
                    `${userName} failed to update status to "${modalStatus}" for ${selectedStatusRecord.id}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    selectedStatusRecord.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Status_ByID_UPDATE',
                    'FAILED',
                    `failed to update status to "${modalStatus}" for ${selectedStatusRecord.id}`
                );
            }

        } catch (err) {
            insertLog(
                `${userName} failed to update status to "${modalStatus}" for ${selectedStatusRecord.id}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                selectedStatusRecord.id || '',
                'UPDATE',
                'WS_OutgoingRequest_Status_ByID_UPDATE',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Failed to  update status.", [
                { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
            ]);
        }
        finally {
            stopHudRotation();
        }


        setShowStatusModal(false);

    }

    const handlePageSizeChange = async (value) => {
        const newSize = Number(value);

        setPageSize(newSize);
        setCurrentPage(1);

        // RESET EVERYTHING
        setrequestSentByPage({});
        setLoadedPages([]);
        setHasMorePages(false);   // 🔥 IMPORTANT FIX

        await LoadRecords(1, true, newSize);
    };

    // // ✅ Open Add Cheque Modal
    // const handleOpenChequeModal = (requestID) => {
    //     setSelectedChequeRecordId(requestID);
    //     setChequePaymentTo("");
    //     setChequeAmount("");
    //     setShowChequeModal(true);
    // };

    // const [chequeData, setChequeData] = useState(null);


    // const [chequeMemo, setChequeMemo] = useState("");

    // const [chequeAddress, setChequeAddress] = useState({
    //     address: "",
    //     city: "",
    //     state: "",
    //     zip: ""
    // });
    const [chequeData, setChequeData] = useState(null);
    // const [chequePaymentTo, setChequePaymentTo] = useState("");
    // const [chequeAmount, setChequeAmount] = useState("");
    const [chequeMemo, setChequeMemo] = useState("");
    const [chequeAddress, setChequeAddress] = useState({
        address: "",
        city: "",
        state: "",
        zip: ""
    });

    // Function to fetch agency address by ID
    const fetchAgencyAddress = async (agencyID) => {
        try {
            if (!agencyID) {
                showToast({ message: "Agency ID missing" });
                return;
            }

            hud("Loading agency details...");

            const req = { agencyID };

            const response = await requestSentDS.WS_Agency_Address_ById_GET(req);
            const data = response.data;

            const body =
                typeof data.body === "string"
                    ? JSON.parse(data.body)
                    : data.body;

            if (data.statusCode === 200 && body?.record) {
                const record = body.record;

                // ✅ AUTO FILL FIELDS
                setChequePaymentTo(record.agencyDisplayName || "");

                setChequeAddress({
                    address: record.agencyAddress?.address || "",
                    city: record.agencyAddress?.city || "",
                    state: record.agencyAddress?.state || "",
                    zip: record.agencyAddress?.zip || ""
                });

            } else {
                showToast({ message: "Agency record not found" });
                insertLog(
                    `${userName} failed to fetch agency address for agency ${agencyID}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    agencyID || '',
                    'GET',
                    'WS_Agency_Address_ById_GET',
                    'FAILED',
                    `failed to fetch agency address for agency ${agencyID}`
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch agency address for agency ${agencyID}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                agencyID || '',
                'GET',
                'WS_Agency_Address_ById_GET',
                'FAILED',
                err.message
            );
            console.error("Error fetching agency address:", err);
            showToast({ message: "Error fetching agency details" });
        } finally {
            stopHudRotation();
        }
    };



    // Call this when opening the cheque modal for adding a new cheque
    const handleOpenChequeModal = (agencyID, requestID) => {
        setShowChequeModal(true);
        setSelectedChequeRecordId(requestID);

        // RESET FIELDS
        setChequeData(null);
        setChequeAmount("");
        setChequeMemo("");

        setChequeAddress({
            address: "",
            city: "",
            state: "",
            zip: ""
        });

        // ✅ AUTO LOAD AGENCY DATA
        fetchAgencyAddress(agencyID);
    };

    // Example usage:
    // <button onClick={() => handleOpenChequeModal("693924088ae630338a2497b3")}>Add Cheque</button>

    // user info
    const [email, setEmail] = useState('');
    const [sub, setSub] = useState('');
    useEffect(() => {
        setEmail(localStorage.getItem('email') || '');
        setSub(localStorage.getItem('sub') || '');
    }, []);

    useEffect(() => {
        if (email && sub) {
            fetchDatasets();
        }
    }, [email, sub]);
    const handleCloseChequeModal = () => {
        setShowChequeModal(false);
        setSelectedChequeRecordId(null);
        setChequeData(null);
        setChequePaymentTo("");
        setChequeAmount("");
        setChequeMemo("");
        setChequeAddress({
            address: "",
            city: "",
            state: "",
            zip: ""
        });
    };
    const handleAmountChange = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) {
            setChequeAmount(value);
        }
    };
    function numberToWords(amount) {
        const integer = Math.floor(amount);
        const decimal = Math.round((amount - integer) * 100);

        let words = `${integer} DOLLARS`;
        if (decimal > 0) words += ` AND ${decimal} CENTS`;
        return words;
    }

    // const handleGenerateCheque = async (e) => {
    //     e.preventDefault();

    //     if (!chequePaymentTo.trim()) {
    //         showToast({ message: "Please enter Payment To" });
    //         return;
    //     }

    //     if (!chequeAmount.trim()) {
    //         showToast({ message: "Please enter Amount" });
    //         return;
    //     }

    //     hud("Generating Cheque...");

    //     try {
    //         const req = {
    //             requestID: selectedChequeRecordId,
    //             cheque: {
    //                 payableTo: chequePaymentTo,
    //                 amount: parseFloat(chequeAmount),
    //                 amountInWords: numberToWords(parseFloat(chequeAmount)),
    //                 address: chequeAddress,
    //                 memo: chequeMemo,
    //                 created_by_email_id: email
    //             }
    //         };

    //         const response = await requestSentDS.WS_OutgoingRequest_Cheque_Generate(req);
    //         const data = response.data;
    //         const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

    //         if (data.statusCode === 200) {
    //             showToast({ message: "Cheque generated and uploaded successfully!" });
    //             handleCloseChequeModal();
    //             handleSearch();
    //             insertLog(
    //                 `${userName} generated a cheque for request '${selectedChequeRecordId}'`,
    //                 0,
    //                 useremail,
    //                 hud,
    //                 stopHudRotation,
    //                 showAlert,
    //                 selectedChequeRecordId || '',
    //                 'INSERT',
    //                 'WS_OutgoingRequest_Cheque_Generate',
    //                 'SUCCESS',
    //                 ''
    //             );
    //         } else {
    //             showAlert(body?.message || "Failed to generate cheque.", [
    //                 { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
    //             ]);
    //             insertLog(
    //                 `${userName} failed to generate cheque for request '${selectedChequeRecordId}'`,
    //                 0,
    //                 useremail,
    //                 hud,
    //                 stopHudRotation,
    //                 showAlert,
    //                 selectedChequeRecordId || '',
    //                 'INSERT',
    //                 'WS_OutgoingRequest_Cheque_Generate',
    //                 'FAILED',
    //                 'failed to generate cheque for request'
    //             );
    //         }
    //     } catch (err) {
    //         insertLog(
    //             `${userName} failed to generate cheque for request '${selectedChequeRecordId}'`,
    //             0,
    //             useremail,
    //             hud,
    //             stopHudRotation,
    //             showAlert,
    //             selectedChequeRecordId || '',
    //             'INSERT',
    //             'WS_OutgoingRequest_Cheque_Generate',
    //             'FAILED',
    //             err.message
    //         );
    //         showAlert(err.message || "Failed to generate cheque.", [
    //             { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
    //         ]);
    //     } finally {
    //         stopHudRotation();
    //     }
    // };
    const [viewChequeRequestId, setViewChequeRequestId] = useState("");

    // ✅ View Cheque Function - Updated


    // const handleViewCheque = async (cheque, requestID) => {
    //     if (!cheque?.s3Key) return;

    //     hud("Loading Cheque...");

    //     try {
    //         const req = { s3Key: cheque.s3Key };
    //         const response = await requestSentDS.WS_OutgoingRequest_Cheque_PresignedUrl_GET(req);

    //         const data = response.data;
    //         const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

    //         if (data.statusCode === 200 && body.presignedUrl) {
    //             setChequePdfUrl(body.presignedUrl);
    //             setViewChequeRequestId(requestID);
    //             setShowViewChequeModal(true);
    //         } else {
    //             showAlert(body?.message || "Failed to load cheque.", [
    //                 { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
    //             ]);
    //             insertLog(
    //                 `${userName} failed to view cheque for request '${requestID}'`,
    //                 0,
    //                 useremail,
    //                 hud,
    //                 stopHudRotation,
    //                 showAlert,
    //                 requestID || '',
    //                 'GET',
    //                 'WS_OutgoingRequest_Cheque_PresignedUrl_GET',
    //                 'FAILED',
    //                 'failed to view cheque for reques'
    //             );
    //         }
    //     } catch (err) {
    //         insertLog(
    //             `${userName} failed to view cheque for request '${requestID}'`,
    //             0,
    //             useremail,
    //             hud,
    //             stopHudRotation,
    //             showAlert,
    //             requestID || '',
    //             'GET',
    //             'WS_OutgoingRequest_Cheque_PresignedUrl_GET',
    //             'FAILED',
    //             err.message
    //         );
    //         showAlert(err.message || "Failed to load cheque.", [
    //             { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
    //         ]);
    //     } finally {
    //         stopHudRotation();
    //     }
    // };

    // ✅ Close View Cheque Modal
    const handleCloseViewChequeModal = () => {
        setShowViewChequeModal(false);
        setChequePdfUrl("");
        setViewChequeRequestId("");
    };


    const formatToLocalDateTime = (timestamp) => {
        if (!timestamp) return "";

        const normalized = typeof timestamp === "string"
            ? timestamp.trim().replace(" ", "T")
            : timestamp;

        const date = new Date(normalized);

        if (isNaN(date.getTime())) return "";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const startEntry = totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1;

    const endEntry = Math.min(currentPage * pageSize, totalRecords);



    const handleSort = (column) => {
        const newOrder =
            lastSortedColumn === column && lastSortOrder === "asc" ? "desc" : "asc";

        setLastSortedColumn(column);
        setLastSortOrder(newOrder);

        // Sort current page immediately
        const pageRecords = requestSentByPage[currentPage] || [];
        const sortedRecords = sortRecords(pageRecords, column, newOrder);
        setrequestSentByPage(prev => ({ ...prev, [currentPage]: sortedRecords }));
    };

    const sortRecords = (records, column, order) => {
        return [...records].sort((a, b) => {
            let valueA = "";
            let valueB = "";

            if (column === "agencyName") {
                valueA = `${a.agencyID ?? ""}-${a.agencyName ?? ""}`.toLowerCase();
                valueB = `${b.agencyID ?? ""}-${b.agencyName ?? ""}`.toLowerCase();
            }
            else if (column === "triggeredOnDate") {
                const dateA = new Date(a.triggeredOnDate).getTime() + (a.triggeredAtHour ?? 0) * 3600000;
                const dateB = new Date(b.triggeredOnDate).getTime() + (b.triggeredAtHour ?? 0) * 3600000;

                valueA = dateA;
                valueB = dateB;
            }

            if (order === "asc") return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
            return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
        });
    };



    // const filteredData = requestSentData.filter((req) => {
    //     if (!search) return true;
    //     const lowerSearch = search.toLowerCase();

    //     return (
    //         (req.requestID?.toString().toLowerCase().includes(lowerSearch)) ||
    //         (req.agencyID?.toString().toLowerCase().includes(lowerSearch)) ||
    //         (req.agencyName?.toLowerCase().includes(lowerSearch)) 
    //     );
    // });


    const dateFormatRecord = (dateString) => {
        if (!dateString) return "NA";

        const normalized = typeof dateString === "string"
            ? dateString.trim().replace(" ", "T")
            : dateString;

        const date = new Date(normalized);

        if (isNaN(date.getTime())) return "NA";

        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    };

    const shouldShowCallIcon = (req) => {

        if (!req) return false;

        if (req.filesCount > 0) {
            return false;
        }

        if (req.url) return false;

        if (!req.TriggerEvents || req.TriggerEvents.length === 0) {
            return true;
        }

        const waitDays = Number(req.TriggerEvents[0]?.waitDays ?? 0);

        if (!req.triggeredOnDate) return false;

        const [year, month, day] = req.triggeredOnDate
            .split("-")
            .map(Number);

        const triggeredHour = Number(req.triggeredAtHour ?? 0);

        // Trigger time in ET
        const triggerET = new Date(
            `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}T${String(triggeredHour).padStart(2, "0")}:00:00`
        );

        const threshold = new Date(triggerET);
        threshold.setDate(threshold.getDate() + waitDays);

        const nowET = new Date(
            new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
        );

        return nowET >= threshold;

    };

    const openModal = (requestID) => {
        setDialOpen(true);
        setDialRequestId(requestID);
    }


    return (
        <div className="main-content">
            <div className="custom-header-req">
                <span className="title-req">Winter Solider Outgoing Request</span>
            </div>
            <div className="mt-3">
                <div className="pagination-wrapper-req">
                    <span className="showing-text">
                        Showing {startEntry} to {endEntry} of {totalRecords} entries
                    </span>

                    {/* Limit Dropdown */}
                    <span>Show</span>

                    <select
                        className="form-select"
                        value={pageSize}
                        disabled={!isPageSizeEnabled}
                        onChange={(e) => handlePageSizeChange(e.target.value)}
                    >
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>

                    {/* Pagination */}
                    <ul className="pagination-req">
                        <li>
                            <button
                                className="page-btn-req"
                                disabled={currentPage === 1}
                                onClick={() => handlePageChange(currentPage - 1)}
                            >
                                &lt;
                            </button>
                        </li>
                        <li>
                            <button className="page-btn-req page-btn-active">{currentPage}</button>
                        </li>
                        <li>
                            <button
                                className="page-btn-req"
                                disabled={currentPage === totalPages || requestSentData.length === 0}
                                onClick={() => handlePageChange(currentPage + 1)}
                            >
                                &gt;
                            </button>
                        </li>
                    </ul>
                </div>


                <div className="table-content-req">

                    <form className="filter-row" onSubmit={handleSearch} >
                        {/* Dataset */}
                        <div className="filter-item">
                            <label>Dataset</label>
                            <select
                                className="form-select"
                                value={datasetID}
                                onChange={handleDatasetChange}
                            >
                                <option>Select Dataset</option>
                                {datasets.map((ds) => (
                                    <option key={ds.id} value={ds.datasetID}>
                                        {ds.datasetName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Agency */}
                        <div className="filter-item">
                            <label>Agency</label>
                            <div
                                className={`req-search-select ${!datasetID || datasetID === "Select Dataset" ? "disabled" : ""}`}
                                onBlur={(event) => {
                                    if (!event.currentTarget.contains(event.relatedTarget)) {
                                        setIsAgencyDropdownOpen(false);
                                    }
                                }}
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    value={agencySearch}
                                    onChange={handleAgencySearchChange}
                                    onFocus={(event) => {
                                        setIsAgencyDropdownOpen(true);
                                        setShowAllAgencyOptions(false);
                                        event.target.select();
                                    }}
                                    onKeyDown={handleAgencyKeyDown}
                                    placeholder="All Agencies"
                                    autoComplete="off"
                                    disabled={!datasetID || datasetID === "Select Dataset"}
                                />

                                <button
                                    className="req-search-select-toggle"
                                    type="button"
                                    onClick={() => {
                                        if (!showAllAgencyOptions) {
                                            setShowAllAgencyOptions(true);
                                            setIsAgencyDropdownOpen(true);
                                            return;
                                        }
                                        setShowAllAgencyOptions(false);
                                        setIsAgencyDropdownOpen(false);
                                    }}
                                    aria-label="Toggle agency options"
                                    disabled={!datasetID || datasetID === "Select Dataset"}
                                >
                                    <FaChevronDown />
                                </button>

                                {isAgencyDropdownOpen && (
                                    <div className="req-search-select-menu">
                                        <button
                                            type="button"
                                            className={`req-search-select-option ${!agencyId ? "selected" : ""}`}
                                            onMouseDown={(event) => event.preventDefault()}
                                            onClick={selectAllAgencies}
                                        >
                                            All Agencies
                                        </button>

                                        {filteredAgencyOptions.length > 0 ? (
                                            filteredAgencyOptions.map((agency, index) => (
                                                <button
                                                    key={`${agency._id || agency.id || agency.agencyID || getAgencyLabel(agency)}-${index}`}
                                                    type="button"
                                                    className={`req-search-select-option ${agencyId === agency.agencyID ? "selected" : ""}`}
                                                    onMouseDown={(event) => event.preventDefault()}
                                                    onClick={() => selectAgencyOption(agency)}
                                                >
                                                    {getAgencyLabel(agency)}
                                                </button>
                                            ))
                                        ) : (
                                            <div className="req-search-select-empty">
                                                No agencies found
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* From Date */}
                        <div className="filter-item">
                            <label>From</label>
                            <input
                                type="date"
                                className="form-control"
                                value={fromDate}
                                onChange={handleFromDateChange}
                            />
                        </div>

                        {/* To Date */}
                        <div className="filter-item">
                            <label>To</label>
                            <input
                                type="date"
                                className="form-control"
                                value={toDate}
                                onChange={handleToDateChange}
                            />
                        </div>

                        {/* Search Button */}
                        <div className="search-box">
                            <button type="submit" className="w-100">
                                Search
                            </button>
                        </div>
                    </form>

                    {selectedAgencyDetails && (
                        <div className="agency-card mt-4">

                            <div className="agency-header" onClick={() => setIsOpen(!isOpen)}>
                                <div className="header-left">
                                    <h3 className="agency-title">Agency & Dataset Details</h3>
                                </div>

                                <div className="header-right">
                                    <span className={`chevron ${isOpen ? "open" : ""}`}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                                            <path d="M6 9l6 6 6-6" />
                                        </svg>
                                    </span>
                                </div>
                            </div>

                            {isOpen && (
                                <div className="agency-body">
                                    <div className="info-grid">

                                        {/* Dataset */}
                                        <div className="info-item">
                                            <span className="info-label">DATASET</span>
                                            <span className="info-value">{selectedAgencyDetails.datasetID}</span>
                                        </div>

                                        {/* Agency */}
                                        <div className="info-item">
                                            <span className="info-label">AGENCY</span>
                                            <span className="info-value">{selectedAgencyDetails.agencyName}</span>
                                        </div>

                                        {/* Contact Person */}
                                        <div className="info-item">
                                            <span className="info-label">CONTACT PERSON</span>
                                            <span className="info-value">{selectedAgencyDetails.agencyContactPerson}</span>
                                        </div>

                                        {/* Phone */}
                                        <div className="info-item">
                                            <span className="info-label">PHONE</span>
                                            <span className="info-value">{phoneNumber}</span>
                                        </div>

                                        {/* Frequency Type */}
                                        <div className="info-item full-row">
                                            <span className="info-label">FREQUENCY TYPE</span>
                                            <span className="info-value">{selectedAgencyDetails?.frequency?.frequencyType || ""}
                                            </span>
                                        </div>

                                        {/* Weekdays */}
                                        <div className="info-item">
                                            <span className="info-label">Weekdays</span>
                                            <span className="info-value">
                                                {formatListValue(selectedAgencyDetails?.frequency?.frequencySettings?.weekDays)}
                                            </span>
                                        </div>

                                        {/* Time */}
                                        <div className="info-item">
                                            <span className="info-label">TIME (hour)</span>
                                            <span className="info-value">
                                                {selectedAgencyDetails?.frequency?.frequencySettings?.time || ""}
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            )}

                        </div>
                    )}

                    <div class="table-shadow-wrapper">

                        <div
                            className={`table-wrapper-req ${selectedAgencyDetails && isOpen ? "agency-open" : ""} ${selectedAgencyDetails && !isOpen ? "agency-closed" : ""}`} >

                            <table className="reqsent-table" >
                                <thead className="thead-dark">
                                    <tr>
                                        <th className="request-id-col" style={{ textAlign: "center" }}>Request Id</th>
                                        <th
                                            onClick={() => handleSort("agencyName")}
                                            style={{ width: "22%", textAlign: "center", paddingLeft: "50px", cursor: "pointer" }}
                                        >
                                            Agency
                                            <span style={{ marginLeft: "6px" }}>
                                                {lastSortedColumn === "agencyName" ? (
                                                    lastSortOrder === "asc" ? (
                                                        <TbTriangleFilled size={11} color="#EC6438" />
                                                    ) : (
                                                        <TbTriangleInvertedFilled size={11} color="#EC6438" />
                                                    )
                                                ) : (
                                                    <LuTriangle size={11} color="var(--black)" />
                                                )}
                                            </span>
                                        </th>

                                        <th
                                            onClick={() => handleSort("triggeredOnDate")}
                                            style={{ width: "12%", textAlign: "center", whiteSpace: "nowrap", cursor: "pointer" }}
                                        >
                                            Requested Date
                                            <span style={{ marginLeft: "6px" }}>
                                                {lastSortedColumn === "triggeredOnDate" ? (
                                                    lastSortOrder === "asc" ? (
                                                        <TbTriangleFilled size={11} color="#EC6438" />
                                                    ) : (
                                                        <TbTriangleInvertedFilled size={11} color="#EC6438" />
                                                    )
                                                ) : (
                                                    <LuTriangle size={11} color="var(--black)" />
                                                )}
                                            </span>
                                        </th>




                                        <th style={{ width: "10%", textAlign: "center" }}>Files & Cases</th>
                                        <th style={{ width: "10%", textAlign: "center" }}>Link</th>
                                        <th style={{ width: "10%", textAlign: "center" }}>Notes</th>
                                        {/* <th style={{ width: "10%", textAlign: "center" }}>Cheques</th> */}
                                        <th style={{ width: "10%", textAlign: "center" }}>Status</th>
                                        <th style={{ width: "10%", textAlign: "center" }}>Req Pdf</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {requestSentData.length === 0 ? (
                                        <tr className="no-record-row">
                                            <td colSpan="9" className="text-center">
                                                No Records Found
                                            </td>
                                        </tr>
                                    ) : (
                                        requestSentData.map((req, index) => (
                                            <tr key={req.id || index}>

                                                <td className="selectable-text request-id-col">
                                                    {shouldShowCallIcon(req) && (
                                                        <BiSolidPhoneCall className="call-icon"
                                                        // onClick={() => openModal(req.requestID)}
                                                        />
                                                    )}&ensp;
                                                    <span
                                                        style={{ color: "#09c", cursor: "pointer", textDecoration: "underline" }}
                                                        onClick={async () => {
                                                            sessionStorage.setItem("reqSent_filters", JSON.stringify({
                                                                datasetID,
                                                                agencyId,
                                                                agencyMongoId,
                                                                fromDate,
                                                                toDate,
                                                                currentPage,
                                                                pageSize,
                                                                requestSentByPage,
                                                                loadedPages,
                                                                hasMorePages,
                                                                totalRecords,
                                                                lastSortedColumn,
                                                                lastSortOrder,
                                                                selectedAgencyDetails,
                                                                isOpen
                                                            }));
                                                            try {
                                                                hud("Loading details...");
                                                                const response = await requestSentDS.WS_OutgoingRequest_Details_GET({
                                                                    requestID: req.requestID
                                                                });

                                                                const data = response.data;
                                                                const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

                                                                if (data.statusCode === 200 && body) {
                                                                    const fullRecord = {
                                                                        ...body, id: body._id, filesCount: body.filesCount ?? req.filesCount ?? 0,
                                                                        casesCount: body.casesCount ?? req.casesCount ?? 0
                                                                    };
                                                                    stopHudRotation();
                                                                    console.log("Body:", body)
                                                                    console.log("fullRecord:", fullRecord)
                                                                    navigate(`/RequestDetail?requestID=${req.requestID}`, {
                                                                        state: { record: fullRecord }
                                                                    });
                                                                } else {
                                                                    stopHudRotation();
                                                                    navigate(`/RequestDetail?requestID=${req.requestID}`, {
                                                                        state: { record: req }
                                                                    });
                                                                }
                                                            } catch (err) {
                                                                stopHudRotation();
                                                                navigate(`/RequestDetail?requestID=${req.requestID}`, {
                                                                    state: { record: req }
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        {req.requestID}
                                                    </span>
                                                    <FaCopy style={{ marginLeft: "8px", cursor: "pointer", color: "#09c" }}
                                                        title="Copy"
                                                        onClick={() => handleCopy(req.requestID)}
                                                    />
                                                </td>
                                                <td className="agency-col">
                                                    <div className="agency-content">


                                                        <span onClick={async () => {
                                                            const agencyIDForPayload = req.agencyID || req.agencyId || agencyId || "";
                                                            const selectedAgency = agencies.find((agency) => String(agency.agencyID || agency.agencyId) === String(agencyIDForPayload));
                                                            const fullAgency = await getAgencyRecordForDetailsNavigation(selectedAgency);
                                                            const agencySource = fullAgency || selectedAgency || {};
                                                            const datasetIDForPayload = req.datasetID || req.dataSetId || agencySource.datasetID || agencySource.dataSetId || datasetID || "";
                                                            const selectedDataset = datasets.find((ds) => ds.datasetID === datasetIDForPayload);
                                                            const datasetNameForPayload = req.datasetName || req.dataSetName || agencySource.datasetName || agencySource.dataSetName || selectedDataset?.datasetName || selectedDataset?.dataSetName || "";
                                                            const payload = {
                                                                ...req,
                                                                ...agencySource,
                                                                datasetID: datasetIDForPayload,
                                                                datasetName: datasetNameForPayload,
                                                                agencyID: agencyIDForPayload,

                                                                agencyName:
                                                                    agencySource.agencyName ||
                                                                    agencySource.agencyDisplayName ||
                                                                    req.agencyName ||
                                                                    "",

                                                                // agencyDisplayName:
                                                                //     agencySource.agencyDisplayName ||
                                                                //     agencySource.agencyName ||
                                                                //     req.agencyDisplayName ||
                                                                //     "",

                                                                agencyPhoneNumber:
                                                                    agencySource.agencyPhoneNumber ||
                                                                    agencySource.agencyPhoneNumbers?.find(p => p.isPrimary)?.number ||
                                                                    agencySource.agencyPhoneNumbers?.[0]?.number ||
                                                                    req.agencyPhoneNumber ||
                                                                    "",

                                                                requestType: agencySource.requestMethod?.requestType || "",
                                                                responseType: agencySource.responseMethod?.responseType || "",

                                                                // requestMethod: agencySource.requestMethod || {},
                                                                // responseMethod: agencySource.responseMethod || {},
                                                            };

                                                            localStorage.setItem("agencyDetailsPayload", JSON.stringify(payload));

                                                            // Open in new tab with URL parameters
                                                            const url = `/AgencyDetailPage`;
                                                            window.open(url, "_blank");
                                                        }} style={{ color: "#09c", cursor: "pointer" }} className="agency-text">

                                                            {req.agencyID && req.agencyName
                                                                ? `${req.agencyID} - ${req.agencyName}`
                                                                : "NA"}
                                                        </span>

                                                    </div>

                                                </td>

                                                <td
                                                    style={{
                                                        width: "12%",
                                                        whiteSpace: "nowrap",
                                                        textAlign: "center"
                                                    }}
                                                >
                                                    {req.triggeredOnDate
                                                        ? `${dateFormatRecord(req.triggeredOnDate)}`
                                                        : "NA"}
                                                </td>


                                                <td style={{ width: "6%", textAlign: "center" }}>
                                                    {/* {`${req.filesCount}/${req.casesCount}`} */}
                                                    {
                                                        req.filesCount === 0
                                                            ? 'No Files'
                                                            : (req.casesCount || 0) === 0
                                                                ? `${req.filesCount} ${req.filesCount === 1 ? 'File' : 'Files'} & Cases Yet to Start`
                                                                : `${req.filesCount} ${req.filesCount === 1 ? 'File' : 'Files'} with ${req.casesCount} ${req.casesCount === 1 ? 'Case' : 'Cases'}`
                                                    }
                                                </td>
                                                {/* <td style={{ width: "6%", textAlign: "center" }}>
                                                    {req.notes?.some(note => note.gmail_link) ? (
                                                        <a
                                                            href={req.notes.find(note => note.gmail_link)?.gmail_link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{
                                                                color: "#09c",
                                                                fontSize: "20px",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            <PiLink />
                                                        </a>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td> */}

                                                <td style={{ width: "6%", textAlign: "center" }}>
                                                    {req.url ? (
                                                        <a
                                                            href={req.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{
                                                                color: "#09c",
                                                                fontSize: "20px",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            <PiLink />
                                                        </a>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>


                                                {/* <td style={{ width: "10%", textAlign: "center" }}>
                                                    {req.cheque ? (
                                                        <a
                                                            href="#"
                                                            className="table-link"
                                                            style={{ color: "#09c" }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleViewCheque(req.cheque, req.requestID);
                                                            }}
                                                        >
                                                            View Cheque
                                                        </a>
                                                    ) : (
                                                        <a
                                                            href="#"
                                                            className="table-link"
                                                            style={{ color: "#09c" }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleOpenChequeModal(req.agencyID, req.id);
                                                            }}
                                                        >
                                                            Add Cheque
                                                        </a>

                                                    )}
                                                </td> */}
                                                <td style={{ width: "10%", textAlign: "center" }}>
                                                    <span className="action-icon-req">
                                                        <FaEye
                                                            onClick={() => handleViewNotes(req.notes || [])}
                                                            style={{ cursor: 'pointer' }}
                                                        />


                                                    </span>
                                                </td>

                                                <td style={{ width: "10%", textAlign: "center" }}>
                                                    <span className="action-icon-status">

                                                        <FaEdit
                                                            className="status-edit-icon"
                                                            onClick={() => openStatusModal(req)}
                                                        />

                                                        <span className="current-status-text">
                                                            {req.outgoingRequest_Status || "Sent"}  {/* Use req.status here */}
                                                        </span>

                                                    </span>
                                                </td>
                                                <td style={{ width: "6%", textAlign: "center" }}>
                                                    <span className="action-icon-req">
                                                        <FaEye
                                                            onClick={() => handleViewPDF(
                                                                req.pdfForm?.s3Key,
                                                                req.datasetID,
                                                                req.datasetName
                                                            )}
                                                        />
                                                    </span>
                                                </td>

                                            </tr>
                                        ))
                                    )}
                                </tbody>

                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {showAddModal && (
                <div className='add-text-req'>
                    <div className='add-text-req-body'>

                        <div className='add-text-reqheader'>
                            <span>Add Note</span>
                            <MdCancel size={24} className='closeAddForm' onClick={handleCloseModal} />
                        </div>

                        <form onSubmit={handleTextSubmit}>
                            <div className="req-text-field">
                                <label className="form-label">
                                    Note<span className="asterisk-req"><FaAsterisk /></span>
                                </label>

                                <textarea
                                    className={`form-control ${noteerror ? "input-error" : ""}`}
                                    rows={3}
                                    value={textArea}
                                    onChange={(e) => {
                                        setTextArea(e.target.value);
                                        setNoteError("");
                                    }}
                                    placeholder="Enter notes"

                                />
                                {noteerror && <div className="text-error">{noteerror}</div>}

                                <button type="submit" className="req-text-field-btn mt-3">
                                    Submit
                                </button>
                            </div>
                        </form>

                    </div>
                </div>

            )}


            {/* Notes Modal */}
            {showNotesModal && (
                <div className="notes-status-overlay">
                    <div className="notes-status">
                        <div className="notes-status-header">
                            <span>Notes</span>
                            <MdCancel size={24} className="closeAddForm" onClick={() => setShowNotesModal(false)} />
                        </div>

                        <div className="notes-view-body">
                            {[...currentNotes]
                                .filter(note => note.text?.trim())
                                .sort((a, b) => {
                                    if (b.isPinned !== a.isPinned) return (b.isPinned ? 1 : 0) - (a.isPinned ? 1 : 0);
                                    const dateA = new Date(a.createdAt || a.time || a.addedTimestamp || 0);
                                    const dateB = new Date(b.createdAt || b.time || b.addedTimestamp || 0);
                                    return dateB - dateA;
                                })
                                .map((note, idx) => {
                                    const rawText = note.text || "";
                                    const first50Chars = rawText.substring(0, 50);
                                    const matchedStatus = viewHighlightFileds.find(status =>
                                        first50Chars.startsWith(status)
                                    );

                                    return (
                                        <div key={idx} className={`note-item ${note.isPinned ? "note-pinned" : ""}`}>
                                            <p className="note-text">
                                                <GoDotFill size={12} />{" "}
                                                {note.isPinned && (
                                                    <span className="pinned-badge">
                                                        <BsPinAngleFill size={10} /> Pinned
                                                    </span>
                                                )}
                                                {matchedStatus ? (
                                                    <>
                                                        <span className="status-highlight">{matchedStatus}</span>
                                                        {" "}
                                                        {rawText.substring(matchedStatus.length).trim()}
                                                    </>
                                                ) : (
                                                    rawText
                                                )}
                                            </p>
                                            <p className="note-meta">
                                                {note.updated_by_email_id || note.addedBy} at {formatToLocalDateTime(note.addedTimestamp)}
                                            </p>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
            )}



            {showStatusModal && (
                <div className="notes-status-overlay">
                    <div className="notes-status">
                        <div className="notes-status-header">
                            <span>Update Status</span>
                            <MdCancel
                                size={24}
                                className="closeAddForm"
                                onClick={() => setShowStatusModal(false)}
                            />
                        </div>

                        {/* FORM START */}
                        <form className="notes-status-body" onSubmit={handleStatusSubmit}>

                            <div className="req-status-field" style={{ marginBottom: "10px" }}>
                                <label>Status <span className="asterisk-req"><FaAsterisk /></span></label>
                                <select
                                    className="form-control"
                                    value={modalStatus} // patched value
                                    onChange={(e) => setModalStatus(e.target.value)}
                                    required
                                >
                                    <option value="Sent">Sent</option>
                                    {reqStatusOptions.map((s, i) => (
                                        <option key={i} value={s}>{s}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="req-status-field mt-2">
                                <label>Notes <span className="asterisk-req"><FaAsterisk /></span></label>
                                <textarea
                                    className={`form-control ${statusNoteError ? "input-error" : ""}`}
                                    rows="4"
                                    value={statusNotes} // patched value
                                    onChange={(e) => {
                                        setStatusNotes(e.target.value);
                                        setstatusNoteError("");
                                    }}
                                    placeholder="Enter notes"
                                ></textarea>

                                {statusNoteError && (
                                    <div className="text-error">{statusNoteError}</div>
                                )}
                            </div>

                            <div className="submit-btn-container">
                                <button type="submit" className="req-status-field-btn">
                                    Submit
                                </button>
                            </div>

                        </form>

                        {/* FORM END */}
                    </div>
                </div>
            )}

            {/* ✅ Add Cheque Modal */}
            {/* {showChequeModal && (
                <div className="notes-status-overlay">
                    <div className="notes-status">
                        <div className="notes-status-header">
                            <span>{chequeData?.s3Key ? "View Cheque" : "Add Cheque"}</span>
                            <MdCancel size={24} className="closeAddForm" onClick={handleCloseChequeModal} />
                        </div>

                        <div className="notes-status-body">
                            {chequeData?.s3Key ? (
                                <div className="submit-btn-container">
                                    <button
                                        type="button"
                                        className="req-status-field-btn"
                                        onClick={() => handleViewCheque(chequeData)}
                                    >
                                        View Cheque
                                    </button>
                                </div>
                            ) : (
                                <form onSubmit={handleGenerateCheque}>

                                    <div className="req-add-fieldcheque">

                                        <div className="req-form-row">
                                            <div className="req-status-field">
                                                <label>
                                                    Payable To <span className="asterisk-req"><FaAsterisk /></span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter payable to"
                                                    value={chequePaymentTo}
                                                    onChange={(e) => setChequePaymentTo(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="req-status-field">
                                                <label>
                                                    Amount <span className="asterisk-req"><FaAsterisk /></span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter amount"
                                                    value={chequeAmount}
                                                    onChange={handleAmountChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="req-form-row">

                                            <div className="req-left-column">
                                                <div className="req-status-field address-field">
                                                    <label>Address</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={2}
                                                        placeholder="Enter address"
                                                        value={chequeAddress.address}
                                                        onChange={(e) =>
                                                            setChequeAddress({ ...chequeAddress, address: e.target.value })
                                                        }
                                                    />
                                                </div>

                                                <div className="req-status-field">
                                                    <label>Memo</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={3}
                                                        placeholder="Enter memo"

                                                        value={chequeMemo}
                                                        onChange={(e) => setChequeMemo(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="req-right-column">
                                                <div className="req-status-field">
                                                    <label>City</label>
                                                    <input
                                                        className="form-control"
                                                        value={chequeAddress.city}
                                                        placeholder="Enter city"

                                                        onChange={(e) =>
                                                            setChequeAddress({ ...chequeAddress, city: e.target.value })
                                                        }
                                                    />
                                                </div>

                                                <div className="req-status-field">
                                                    <label>State</label>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Enter state"

                                                        value={chequeAddress.state}
                                                        onChange={(e) =>
                                                            setChequeAddress({ ...chequeAddress, state: e.target.value })
                                                        }
                                                    />
                                                </div>

                                                <div className="req-status-field">
                                                    <label>Zip</label>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Enter zip"

                                                        value={chequeAddress.zip}
                                                        onChange={(e) =>
                                                            setChequeAddress({ ...chequeAddress, zip: e.target.value })
                                                        }
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                        <div className="submit-btn-container">
                                            <button type="submit" className="req-status-field-btn">
                                                Generate Cheque
                                            </button>
                                        </div>
                                    </div>


                                </form>
                            )}
                        </div>
                    </div>
                </div>
            )} */}

            {/* ✅ View Cheque Modal - NEW */}
            {showViewChequeModal && (
                <div className="notes-status-overlay">
                    <div className="view-cheque-modal">
                        <div className="notes-status-header">
                            <span className="view-cheque-header">
                                Cheque : ({viewChequeRequestId})
                            </span>

                            <MdCancel
                                size={24}
                                className="closeAddForm"
                                onClick={handleCloseViewChequeModal}
                            />
                        </div>

                        <div className="view-cheque-body">
                            <iframe
                                src={chequePdfUrl}
                                title="Cheque PDF"
                                className="cheque-pdf-viewer"
                            />
                        </div>
                    </div>
                </div>
            )}

            <DialModal
                isOpen={dialOpen}
                onClose={() => setDialOpen(false)}
                requestID={dialRequestId}
            />

        </div>

    )
};
export default RequestSentDetails;
